"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventEmitter = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _nodeEvents = require("node:events");
const isBrowser = typeof window !== 'undefined';
const isEventTarget = manager => manager instanceof EventTarget;
/**
 * Event dispatcher for both browser and server
 */
class EventEmitter {
  constructor() {
    (0, _defineProperty2.default)(this, "manager", void 0);
    /**
     * This mapper serves as a helper to match the bevior of event emmiters on server to client
     */
    (0, _defineProperty2.default)(this, "listenerToBrowserEventListeners", new Map());
    this.manager = isBrowser ? new EventTarget() : new _nodeEvents.EventEmitter();
  }

  /**
   * Adds listener to instance
   */
  addListener(eventName, listener) {
    if (isEventTarget(this.manager)) {
      const customEventListener = event => {
        listener(event.detail);
      };
      const eventListener = customEventListener;
      this.listenerToBrowserEventListeners.set(listener, eventListener);
      this.manager.addEventListener(eventName, eventListener);
    } else {
      // We need to override type this way
      this.manager.addListener(eventName, listener);
    }
  }

  /**
   * Removes listener from disaptcher instance
   */
  removeListener(eventName, listenerReference) {
    if (isEventTarget(this.manager)) {
      const eventListenerUnderReference = this.listenerToBrowserEventListeners.get(listenerReference);
      if (eventListenerUnderReference) {
        this.manager.removeEventListener(eventName, eventListenerUnderReference);
      }
    } else {
      this.manager.removeListener(eventName, listenerReference);
    }
  }

  /**
   * Emit event on dispatcher instance
   */
  emit(eventName, data) {
    if (isEventTarget(this.manager)) {
      this.manager.dispatchEvent(new CustomEvent(eventName, {
        detail: data
      }));
    } else {
      this.manager.emit(eventName, data);
    }
  }
}
exports.EventEmitter = EventEmitter;
